import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import EditorCredit from '../../components/EditorCredit';

export default function MentionsLegales() {
  return (
    <div className="min-h-screen bg-white" data-testid="mentions-legales-page">
      <div className="max-w-3xl mx-auto px-6 sm:px-8 py-12 lg:py-20">
        <Link to="/" className="inline-flex items-center gap-2 text-sm text-[#475569] hover:text-[#0F172A] mb-8">
          <ArrowLeft className="w-4 h-4" /> Retour à l'accueil
        </Link>

        <h1 className="font-display text-4xl lg:text-5xl font-black tracking-tight text-[#0F172A] mb-3">Mentions légales</h1>
        <p className="text-sm text-[#475569] mb-10">Dernière mise à jour : juin 2026</p>

        <div className="prose prose-slate max-w-none space-y-8 text-sm leading-relaxed">
          <section>
            <h2 className="font-display text-xl font-bold text-[#0F172A] mb-3">Éditeur du site</h2>
            <p className="text-[#0F172A]">
              Le site <strong>AssoPerf</strong> est édité par :<br />
              <strong>Osez Studio</strong> — marque de la <strong>SAS Market & Développement</strong><br />
              46100 Figeac · France<br />
              Email : <a href="mailto:market46.d@gmail.com" className="text-blue-600 hover:underline">market46.d@gmail.com</a><br />
              SIRET : <em>(à compléter)</em>
            </p>
          </section>

          <section>
            <h2 className="font-display text-xl font-bold text-[#0F172A] mb-3">Directeur de la publication</h2>
            <p className="text-[#0F172A]">Le représentant légal d'Osez Studio (SAS Market & Développement).</p>
          </section>

          <section>
            <h2 className="font-display text-xl font-bold text-[#0F172A] mb-3">Hébergement</h2>
            <p className="text-[#0F172A]">
              Ce site est hébergé sur une infrastructure cloud sécurisée conforme RGPD (serveurs situés en Union Européenne).
            </p>
          </section>

          <section>
            <h2 className="font-display text-xl font-bold text-[#0F172A] mb-3">Propriété intellectuelle</h2>
            <p className="text-[#0F172A]">
              L'ensemble des éléments présents sur ce site (textes, graphismes, logos, images, code source) est protégé
              par les lois en vigueur sur la propriété intellectuelle. Toute reproduction, totale ou partielle, sans
              autorisation écrite préalable est interdite.
            </p>
            <p className="text-[#0F172A] mt-3">
              Les marques et logos affichés sur AssoPerf par les associations utilisatrices restent la propriété
              exclusive de leurs détenteurs respectifs.
            </p>
          </section>

          <section>
            <h2 className="font-display text-xl font-bold text-[#0F172A] mb-3">Responsabilité</h2>
            <p className="text-[#0F172A]">
              L'éditeur s'efforce de fournir des informations exactes et à jour, mais ne peut garantir l'exactitude,
              la précision ou l'exhaustivité des informations mises à disposition. En conséquence, l'utilisateur
              reconnaît utiliser ces informations sous sa responsabilité exclusive.
            </p>
          </section>

          <section>
            <h2 className="font-display text-xl font-bold text-[#0F172A] mb-3">Contact</h2>
            <p className="text-[#0F172A]">
              Pour toute question ou réclamation, merci d'écrire à :{' '}
              <a href="mailto:market46.d@gmail.com" className="text-blue-600 hover:underline">market46.d@gmail.com</a>
            </p>
          </section>
        </div>

        <div className="mt-12 pt-8 border-t border-[#E2E8F0] flex flex-wrap gap-4 text-xs text-[#475569]">
          <Link to="/cgu" className="hover:text-[#0F172A]" data-testid="link-cgu">CGU</Link>
          <Link to="/confidentialite" className="hover:text-[#0F172A]" data-testid="link-confidentialite">Confidentialité</Link>
          <Link to="/" className="hover:text-[#0F172A]">Accueil</Link>
        </div>
      </div>
      <EditorCredit variant="light" />
    </div>
  );
}
